import styled from 'styled-components'

import { BlobPicture, styles as S, breakpoint, brush, color } from '@bob/design-system'
import { toDataUrl } from '@bob/design-system/src/utils/svg'
import * as entity from '@boutique/entities'
import { RichText } from '@bob/rich-text'

type AuthorProps = {
  article: entity.article.Article
}

export function Author({ article }: AuthorProps): React.ReactElement {
  const authorText = article.author.genre ? 'auteur' : 'autrice'

  return (
    <Section>
      <BrushedText>
        {"À propos de l'"}
        {authorText}
      </BrushedText>
      <Wrapper>
        <BlobPicture size={215} src={article.author.profileImage?.src} />
        <div>
          <div>
            <S.heading.Title3>{article.author.name}</S.heading.Title3>
            <S.copy.Text4>{article.author.quality}</S.copy.Text4>
          </div>
          <RichText
            document={article.author.signature.json}
            links={article.author.signature.links}
            renderNode={{ Paragraph: S.copy.Text1 }}
          />
        </div>
      </Wrapper>
    </Section>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (${breakpoint.TABLET}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 700px;
    margin: 10px auto 0px;
  }
`

const Section = styled.section`
  ${BlobPicture} {
    margin: 0px auto 18px;

    @media screen and (${breakpoint.TABLET}) {
      margin-right: 45px;
    }
  }

  ${S.heading.Title3} {
    font-size: 35px;
    line-height: 48px;
  }

  ${S.copy.Text1} {
    margin: 20px 0px 30px;
    opacity: 0.8;

    @media screen and (${breakpoint.TABLET}) {
      max-width: 296px;
    }
  }

  @media screen and (${breakpoint.TABLET}) {
    margin-bottom: 30px;
  }
`

const brushBackgroundText = toDataUrl(brush.full.FullBrush3, {
  width: 280,
  height: 80,
  fill: color.YELLOW,
})

const BrushedText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 65px;
  height: 80px;
  font-weight: bold;
  font-size: 24px;
  background-repeat: no-repeat;
  background-position: center;

  background-image: url('${brushBackgroundText}');
`
